import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import { Button, message, Form, Input } from 'antd';
import { forgotPassword } from '../../utils/api';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    console.log('Success:', values);
    try {
      await forgotPassword(values);
      message.success('Success! Check email for reset link');
    } catch (err) {
      const msg = err?.response?.data?.message || 'Oops! Something went wrong!';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div id='forgotpassword' className='bg-primaryBlue h-screen flex flex-col'>
      <Navbar />
      <div className='flex flex-1 px-[40px]'>
        <div className='w-1/2 flex justify-center items-center'>
          <img src='/images/landing_page.svg' alt='' className='h-[600px]' />
        </div>
        <div className='w-1/2 flex justify-center items-center'>
          <Form
            layout='vertical'
            name='basic'
            labelCol={{
              span: 10,
            }}
            wrapperCol={{
              span: 24,
            }}
            style={{
              maxWidth: 600,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Form.Item
              label='Email:'
              name='username'
              rules={[
                {
                  type: 'email',
                  required: true,
                  message: 'Please input your email!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 24,
              }}
            >
              <Button
                disabled={loading}
                type='primary'
                htmlType='submit'
                className='border-white bg-transparent'
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
